export enum CustomCategoriesNames {
  homeCategory = 'Home',
  searchResultCategory = 'Search Result',
}

export enum LocalStorageKeys {
  productsCategories = 'productsCategories',
  giftCardImages = 'giftCardImages',
}
